module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/star-icon-42058f98fd2d0b3f086a95050d2cf459.png";